; (function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define ===
		'function' && define.amd ? define(factory) : (global = global || self, global.CSCEC = factory())
}(this, function () {
	'use strict';
	function CSCEC() {
		if (!(this instanceof CSCEC)) {
			console.error('CSCEC is a constructor and should be called with the `new` keyword')
		}
	};
	/**
	 * @description: 定位
	 * @param {*} options
	 * @return {*}
	 */
	CSCEC.getGeolocation = function (options = {}) {
		var option = Object.assign({
			success: options.success || null,
			fail: options.fail || null,
		}, options);
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		if (isAndroid) {
			var _BARCODE = 'cscec';
			var success = typeof option.success !== 'function' ? null : function (args) {
				option.success(args);
			},
				fail = typeof option.fail !== 'function' ? null : function (code) {
					option.fail(code);
				};
			var callbackID = plus.bridge.callbackId(success, fail);
			return plus.bridge.exec(_BARCODE, "getGeolocation", [callbackID]);
		} else {
			plus.geolocation.getCurrentPosition(
				function (result) {
					var latitude = result.coords.latitude;
					var longitude = result.coords.longitude;
					var res = {
						latitude,
						longitude,
						WGSLat: latitude,
						WGSLon: longitude,
						accuracy: result.coords.accuracy
					};
					option.success && option.success(res);
				},
				function (err) {
					option.fail && option.fail(err);
				},
				{ provider: 'system', coordsType: 'wgs84', geocode: true }
			)
		}
	};
	/**
	 * @description: 获取照片
	 * @param {*} options
	 */
	CSCEC.getPicture = function (options = {}) {
		var option = Object.assign({
			showAction: false,
			needCompress: false,
			needBase64: true,
			compress: {},
			success: options.success || null,
			fail: options.fail || null,
		}, options);
		if (window.plus) {
			plusReady()
		} else {
			document.addEventListener('plusready', plusReady, false)
		};

		function plusReady() {
			if (option.showAction === true) {
				showActionSheet()
			} else if (option.type === 'image') {
				galleryImgs()
			} else {
				getImage()
			}
		};

		function exportPic(url, name) {
			plus.io.resolveLocalFileSystemURL(url, function (entry) {
				entry.file(function (file) {
					var fileReader = new plus.io.FileReader();
					fileReader.readAsDataURL(file);
					fileReader.onloadend = function (e) {
						var obj = {
							file,
							e
						};
						if (option.needBase64 === true) {
							obj.base64Url = e.target.result.toString()
						}
						option.success && typeof (option.success) === 'function' &&
							option.success(obj)
					}
				})
			})
		};

		function compressImage(url, filename) {
			var name = "_doc/upload/" + filename;
			plus.zip.compressImage({
				src: url,
				dst: name,
				quality: 100,
				overwrite: true,
				...option.compress
			}, function (zip) {
				exportPic(zip.target, name)
			}, function (error) {
				option.fail && typeof (option.fail) === 'function' && option.fail(error)
			})
		};

		function getImage() {
			var cmr = plus.camera.getCamera();
			cmr.captureImage(function (p) {
				plus.io.resolveLocalFileSystemURL(p, function (entry) {
					if (option.needCompress === true) {
						compressImage(entry.toLocalURL(), entry.name)
					} else {
						entry.file(function (file) {
							var fileReader = new plus.io.FileReader();
							fileReader.readAsDataURL(file);
							fileReader.onloadend = function (e) {
								var obj = {
									file,
									e
								};
								if (option.needBase64 === true) {
									obj.base64Url = e.target.result.toString()
								}
								option.success && typeof (option.success) ===
									'function' && option.success(obj)
							}
						})
					}
				}, function (e) {
					option.fail && typeof (option.fail) === 'function' && option.fail(error)
				})
			}, function (e) {
				option.fail && typeof (option.fail) === 'function' && option.fail(error)
			}, {
				filter: 'image',
			})
		};

		function galleryImgs() {
			plus.gallery.pick(function (e) {
				var name = e.substr(e.lastIndexOf('/') + 1);
				if (option.needCompress === true) {
					compressImage(e, name)
				} else {
					exportPic(e, name)
				}
			}, function (e) { }, {
				filter: "image"
			})
		};

		function showActionSheet() {
			var bts = [{
				title: "拍照"
			}, {
				title: "从相册选择"
			}];
			if (option.type === 'image') {
				bts = [{
					title: "从相册选择"
				}]
			} else if (option.type === 'camera') {
				bts = [{
					title: "拍照"
				}]
			};
			plus.nativeUI.actionSheet({
				cancel: "取消",
				buttons: bts
			}, function (e) {
				if (e.index == 1) {
					getImage()
				} else if (e.index == 2) {
					galleryImgs()
				}
			})
		}
	};
	/**
	 * @description: 人脸识别
	 * @param {*} options
	 * @return {*}
	 */
	CSCEC.openCameraPreview = function (options = {}) {
		var option = Object.assign({
			success: options.success || null,
			fail: options.fail || null,
			type: options.type || 1 // 1: 直接打开 2: 提醒页面
		}, options);
		var _BARCODE = 'cscec';
		var success = typeof option.success !== 'function' ? null : function (args) {
			// 格式化数组拼接成base64
			const ar = Array.isArray(args) ? args: JSON.parse(args)
			if (ar.length) {
				var base64 = ar.map(i => i.str).join('')
				let bitmap = new plus.nativeObj.Bitmap();
				bitmap.loadBase64Data('data:image/png;base64,' + base64);
				bitmap.save(
					"_doc/face.jpg",
					{
						check: true, // 设置为检测白屏
						overwrite: true,
						quality: 100,
					},
					function (i) {
						option.success(JSON.stringify({
							path: '_doc/face.jpg',
						}));
						bitmap.clear()
					},
					function () {
						plus.nativeUI.alert("保存人脸失败,请尝试重新录入");
					}
				);

			}
		},
			fail = typeof option.fail !== 'function' ? null : function (code) {
				option.fail(code);
			};
		var callbackID = plus.bridge.callbackId(success, fail);
		return plus.bridge.exec(_BARCODE, "openCameraPreview", [callbackID, option.type]);

	};
	return CSCEC
}));
